
import circlesAPI from '~/api/circles';

export default {
  name: 'CircleSelector',

  props: {
    value: {
      type: Array | Object,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: 'Select circle',
    },
    labelSize: {
      type: String,
      required: false,
      default: '',
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    clearOnSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    preserveSearch: {
      type: Boolean,
      required: false,
      default: true,
    },
    showLabels: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    accounts: {
      type: Array,
      required: false,
      default: () => [],
    },
    groups: {
      type: Array,
      required: false,
      default: () => [],
    },
    searchable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      circles: [],
      loading: false,
      v: this.normalizeValue(this.value),
      searchQuery: '',
    };
  },
  mounted() {
    this.v = this.normalizeValue(this.value);

    if (!this.searchable) {
      this.grabData({
        ...this.getDefaultParams(),
        include: 'accounts,firm,groups',
      });
    }
  },
  methods: {
    normalizeValue(val) {
      if (this.multiple) {
        if (Array.isArray(val)) return [...val];
        if (val == null) return [];
        return [val];
      } else {
        if (Array.isArray(val)) return val.length ? val[0] : null;
        return val == null ? null : val;
      }
    },

    onSearchChange(val) {
      this.searchQuery = val;
      this.applyFilter(val);
    },

    async applyFilter(val) {
      if (val.length >= 3) {
        const params = {
          ...this.getDefaultParams(),
          'filter[name]': val,
          include: 'accounts,firm,groups',
        };

        await this.grabData(params);
      } else if (!val.length) {
        this.circles = [];
      }
    },

    grabData(params) {
      this.loading = true;

      if (this.accounts && this.accounts.length) {
        params['filter[account_uuids]'] = this.accounts.map((a) => a.uuid).join(',');
      }

      if (this.groups && this.groups.length) {
        params['filter[group_uuids]'] = this.groups.map((g) => g.uuid).join(',');
      }

      circlesAPI
        .allPaged(params)
        .then((rsp) => {
          this.circles = rsp;
          this.loading = false;
        })
        .catch((err) => {
          this.$nuxt.$emit('notification', 'There was an error fetching circles', 'warning', true);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getDefaultParams() {
      return { per_page: 200 };
    },
  },
  watch: {
    v: {
      deep: true,
      handler(newVal) {
        if (this.multiple) {
          this.$emit('input', Array.isArray(newVal) ? newVal : this.normalizeValue(newVal));
        } else {
          this.$emit('input', newVal === undefined ? null : newVal);
        }
      },
    },
  },
};
